export default __webpack_public_path__ + "static/media/Onboarding-Success-Gif.d7b979c4.gif";